import script from "./Folder.vue?vue&type=script&setup=true&lang=js"
export * from "./Folder.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__